import { EventBus } from "../../../eventbus";

export default {
  props: {
    name: String,
    value: Number,
    icon: String,
    label: String,
    value: Number,
    selectedTabIndex: Number,
  },
  data() {
    return {};
  },
  methods: {
    handleInput(e) {
      const value = parseInt(e.currentTarget.value);
      EventBus.$emit(`${this.$options.name}-change`, value);
    },
  },
};
